import { DeleteOutlined, VerifiedUser } from '@mui/icons-material';
import { LinearProgress, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { CustomLink } from '../components/CustomLink';
import Card from '../components/partials/Card';
import Chart from '../components/partials/Chart';
import DataTable from '../components/partials/DataTable';
import PageHeader from '../components/partials/PageHeader';
import { users, userRows } from '../dummyData';

const userColumns = [
	{ field: 'id', headerName: 'ID' },
	{
		field: 'user',
		headerName: 'User',
		width: 200,
		renderCell: (params: any) => {
			return (
				<div className='flex space-x-2 items-center'>
					<img
						src={params.row.avatar}
						className='w-10 h-10 rounded-full'
						alt=''
					/>
					<span>{params.row.username}</span>
				</div>
			);
		},
	},
	{ field: 'email', headerName: 'E-mail' },
	{ field: 'status', headerName: 'Status' },
	{ field: 'transaction', headerName: 'Transaction' },
	{
		field: 'action',
		headerName: 'Action',
		width: 150,
		height: 200,
		renderCell: (params: any) => {
			return (
				<div className='w-full flex items-center justify-between'>
					<CustomLink
						to={`/users/${params.row.id}`}
						className='border-2 border-green-500 hover:bg-green-500 transition-all duration-300 text-green-900 px-5 py-2 rounded-lg'
					>
						Edit
					</CustomLink>
					<button className='hover:bg-red-200 rounded-full p-2 cursor-pointer transition-all duration-300'>
						<DeleteOutlined
							style={{ color: 'red', cursor: 'pointer' }}
						/>
					</button>
				</div>
			);
		},
	},
];

const Home = () => {
	const breadcrumbs = [
		<Link key="1" color='inherit' to='/'>
			Dashboard
		</Link>,
		<Typography key='2' color='text.primary'>
			Home
		</Typography>,
	];

	return (
		<>
			<PageHeader pageTitle={'DASHBOARD'} breadcrumbs={breadcrumbs} />

			{/* Featured Section */}
			<div className='grid grid-cols-1 md:grid-cols-3 gap-y-5 md:gap-x-5'>
				<div className='col-span-2'>
					<div className='card py-5'>
						<Chart
							data={users}
							title='Active User'
							dataKey='Active User'
							grid
						/>
					</div>
				</div>

				<div className='cols-span-1 grid grid-cols-2 gap-3'>
					<Card title='REVENUE'>
						<p className='text-4xl font-semibold'>2755 $</p>
						<span className='text-gray-500 text-sm'>
							This month
						</span>
					</Card>
					<Card title='Users' icon={<VerifiedUser />}>
						<p className='text-4xl font-semibold'>400</p>
						<span className='text-gray-500 text-sm'>New User</span>
					</Card>
					<Card title='SALES'>
						<p className='text-4xl font-semibold'>1055 $</p>
						<span className='text-gray-500 text-sm'>
							This month
						</span>
					</Card>
					<Card title='TICKETS'>
						<p className='text-4xl font-semibold'>154</p>
						<span className='text-gray-500 text-sm'>
							Open Ticket
						</span>
					</Card>
				</div>
			</div>

			<div className='grid grid-cols-1 md:grid-cols-3 mt-5 gap-y-5 md:gap-x-5'>
				<div className='card py-3 col-span-2'>
					<DataTable columns={userColumns} data={userRows} />
				</div>
				<div className='grid-cols-1'>
					<Card title='Sales By Category'>
						<div className='border-b-2 py-4 border-gray-200'>
							<h5 className='text-xl'>Men 75%</h5>
							<LinearProgress
								variant='determinate'
								color='success'
								value={75}
							/>
						</div>
						<div className='border-b-2 py-4 border-gray-200'>
							<h5 className='text-xl'>Women 5%</h5>
							<LinearProgress
								variant='determinate'
								color='secondary'
								value={5}
							/>
						</div>
						<div className='border-b-2 py-4 border-gray-200'>
							<h5 className='text-xl'>Accessories 53%</h5>
							<LinearProgress
								variant='determinate'
								color='warning'
								value={53}
							/>
						</div>
						<div className='border-b-2 py-4 border-gray-200'>
							<h5 className='text-xl'>Electronics 80%</h5>
							<LinearProgress variant='determinate' value={80} />
						</div>
						<div className='border-b-2 py-4 border-gray-200'>
							<h5 className='text-xl'>Dogs 47%</h5>
							<LinearProgress
								variant='determinate'
								color='info'
								value={47}
							/>
						</div>
						<div className='border-b-2 py-4 border-gray-200'>
							<h5 className='text-xl'>Home 12%</h5>
							<LinearProgress
								variant='determinate'
								color='inherit'
								value={12}
							/>
						</div>
					</Card>
				</div>
			</div>
		</>
	);
};

export default Home;
